import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Storage from "@aws-amplify/storage";
import PropTypes from "prop-types";

export const ImageUpload = ({
  logoKey,
  handleUploadImage,
  setPreviewImage = null,
}) => {
  const [imagePreview, setImagePreview] = useState({
    name: "Select an image",
    url: null,
  });

  useEffect(() => {
    async function fetchLogo() {
      if (logoKey) {
        const imgUrl = await Storage.get(logoKey);
        setImagePreview({
          name: "logo-image",
          url: imgUrl,
        });

        // Set preview image to parent components
        if (setPreviewImage) {
          setPreviewImage(imgUrl);
        }
      }
    }

    fetchLogo();
  }, [logoKey, setPreviewImage]);

  async function handleImageChange(e) {
    e.preventDefault();
    let file = e.target.files[0];

    if (!file) return;

    let reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview({ name: file.name, url: reader.result });

      // Set preview image to parent components
      if (setPreviewImage) {
        setPreviewImage(reader.result);
      }
    };

    reader.readAsDataURL(file);

    // Update the "logoFile" and "displayLogo" of menuSetting
    handleUploadImage(file);
  }

  return (
    <div className="previewComponent">
      <div className="d-flex align-items-center menu-upload-file">
        <label className="fileInput-label" htmlFor="imageUpload">
          Choose file
        </label>
        <span className="fileInput-name text-truncate" htmlFor="imageUpload">
          {imagePreview.name}
        </span>
      </div>

      <input
        className="fileInput d-none"
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        id="imageUpload"
      />
      {imagePreview.url && (
        <div className="my-4 previewComponent-wrapper">
          <img src={imagePreview.url} alt="logo-preview" width={86} />
        </div>
      )}
    </div>
  );
};

ImageUpload.propTypes = {
  logoKey: PropTypes.string,
  handleUploadImage: PropTypes.func.isRequired,
  setPreviewImage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ImageUpload);
